import React from 'react';
import styled from 'styled-components';

const MountainsContainer = styled.div`
  id: 'mountains';
  position: relative;
  width: 100%;
  height: 400px; /* Increased to show full mountain SVG */
  margin-top: -250px; /* Reduced to cover less of the hero section */
  background-image: url("/images/mountains/mountain-3.svg");
  background-position: center bottom;
  background-size: cover;
  background-repeat: no-repeat;
  z-index: 20;
  overflow: visible;

  /* Shrink the mountains section on tablets */
  @media (max-width: 768px) {
    height: 250px;
    margin-top: -200px;
    background-size: contain; /* Show full mountain on tablets */
  }

  @media (max-width: 600px) {
    height: 400px;
    margin-top: -360px;
    background-size: contain; /* Show full mountain on mobile */
  }

  /* Further shrink on phones */
  @media (max-width: 480px) {
    height: 400px;
    margin-top: -375px;
    background-size: contain; /* Show full mountain on mobile */
  }

  /* Extra small phones */
  @media (max-width: 375px) {
    height: 200px;
    margin-top: -195px;
    background-size: contain; /* Show full mountain on small phones */
  }

  @media (max-width: 250px) {
    height: 200px;
    margin-top: -200px;
    background-size: contain; /* Show full mountain on small phones */
  }
`;

const StaticMountains: React.FC = () => {
  return <MountainsContainer />;
};

export default StaticMountains; 